<div class="modal-header">
	<div>
		<h3 class="modal-title modal-title-name" >{{name}}</h3>
		<h4 class="modal-title">{{title}}</h4>
	</div>
	<button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
	<div>
		<h4 class="modal-body-section-heading">About</h4>
		<br />
		<p [innerHTML]="message"></p>
	</div>
	<br />
	<div>
		<h4 class="modal-body-section-heading">Work Experience</h4>
		<br />
		<p [innerHTML]="experience"></p>
	</div>
	<br />
	<div>
		<h4 class="modal-body-section-heading">Qualifications</h4>
		<br />
		<p [innerHTML]="qualifications"></p>
	</div>
	<br />
	<div *ngIf="hasPublications">
		<h4 class="modal-body-section-heading">Publications</h4>
		<br />
		<p [innerHTML]="publications"></p>
	</div>
	<br />
	<div *ngIf="hasMemberships">
		<h4 class="modal-body-section-heading">Professional Memberships</h4>
		<br />
		<p [innerHTML]="memberships"></p>
	</div>
	<br />
	<div *ngIf="hasOther">
		<h4 class="modal-body-section-heading">Other</h4>
		<br />
		<p [innerHTML]="other"></p>
	</div>
	<br />
	<div *ngIf="hasSpecialInterests">
		<h4 class="modal-body-section-heading">Special Interests</h4>
		<br />
		<p [innerHTML]="specialInterests"></p>
	</div>

</div>
<!-- <div class="modal-footer">
	<ng-container *ngIf="options.length">
		<button *ngFor="let option of options" type="button" class="btn btn-default" (click)="respond(option)">{{option}}</button>
	</ng-container>
</div> -->
